export const TOGGLE_SEARCH_COMPLETE = 'TOGGLE_SEARCH_COMPLETE';
export const TOGGLE_SEARCH_ERROR = 'TOGGLE_SEARCH_ERROR';

export function toggleSearch(toggle) {
	return async (dispatch, getState) => {
        try {
			dispatch(toggleSearchComplete(toggle));
		} catch (e) {
			console.log(e);
			dispatch(toggleSearchError(e));
		}
	};
}

export function toggleSearchComplete(toggle) {
	return {
		type: TOGGLE_SEARCH_COMPLETE,
		toggle
	};
}

export function toggleSearchError(error) {
	return {
		type: TOGGLE_SEARCH_ERROR,
		error,
	};
}